/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FacilityServiceAreaStatus = {
    Accept: 'Accept',
    Review: 'Review',
    Decline: 'Decline',
} as const;
export type FacilityServiceAreaStatus = typeof FacilityServiceAreaStatus[keyof typeof FacilityServiceAreaStatus];


export function instanceOfFacilityServiceAreaStatus(value: any): boolean {
    for (const key in FacilityServiceAreaStatus) {
        if (Object.prototype.hasOwnProperty.call(FacilityServiceAreaStatus, key)) {
            if (FacilityServiceAreaStatus[key as keyof typeof FacilityServiceAreaStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FacilityServiceAreaStatusFromJSON(json: any): FacilityServiceAreaStatus {
    return FacilityServiceAreaStatusFromJSONTyped(json, false);
}

export function FacilityServiceAreaStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityServiceAreaStatus {
    return json as FacilityServiceAreaStatus;
}

export function FacilityServiceAreaStatusToJSON(value?: FacilityServiceAreaStatus | null): any {
    return value as any;
}

export function FacilityServiceAreaStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): FacilityServiceAreaStatus {
    return value as FacilityServiceAreaStatus;
}

